<template @lo>
  <div class="m-2">
    <b-card title="Black CPF History Transaction">
      <b-row class="mt-2">
        <b-col
          md="12"
          class="mb-md-0 mb-2"
        >
          <b-table
            class="position-relative"
            responsive
            :fields="transactionsTableFields"
            :items="records"
            primary-key="trade_no"
            show-empty
            striped
            :borderless="false"
            empty-text="No matching records found"
          >
            <template #cell(trade_no)="data">
              <b-link
                :to="{ name: 'transactions-detail', query:{trade_no: data.item.trade_no, app_id: data.item.app_id , out_trade_no: data.item.out_trade_no } }"
                target="_blank"
                class="font-weight-bold d-block"
              >
                {{ data.item.trade_no }}
              </b-link>
            </template>

            <template #cell(merchant)="data">
              {{ data.item.merchant_name }}
              <small class="text-muted">@{{ data.item.merchant_no }}</small>
            </template>

            <template #cell(app)="data">
              {{ data.item.app_name }}
              <small class="text-muted">@{{ data.item.app_id }}</small>
            </template>

            <template #cell(order_amount)="data">
              {{ data.item.order_currency }} {{ data.item.order_amount }}
            </template>

            <template #cell(pay_amount)="data">
              {{ data.item.pay_currency }} {{ data.item.pay_amount }}
            </template>

            <template #cell(trade_status)="data">
              <b-badge
                pill
                :variant="`light-${resolveStatusVariant(data.item.trade_status)}`"
              >
                {{ data.item.trade_status }}
              </b-badge>
            </template>
          </b-table>
          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted">{{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }}</span>
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalTransactions"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BBadge, BCard, BRow, BCol, BTable, BLink, BPagination,
} from 'bootstrap-vue'
import amlIdListJs from './amlIdList'

const {
  fetchOrderIdList,
} = amlIdListJs()

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BBadge,
    BLink,
    BPagination,
  },
  data() {
    return {
      searchRequest: {
        id_no: this.$route.query.id_no,
        id_type: this.$route.query.id_type,
      },
      dataMeta: {
        from: 0,
        to: 0,
        of: 0,
      },
      perPage: 10,
      currentPage: 1,
      totalTransactions: 0,
      records: [],
      transactionsTableFields: [
        { key: 'trade_no', label: 'TRANSACTION ID' },
        { key: 'out_trade_no', label: 'MERCHANT REFERENCE' },
        'merchant',
        'app',
        { key: 'create_time', label: 'ORDER TIME' },
        { key: 'order_amount', label: 'ORDER AMOUNT' },
        { key: 'pay_amount', label: 'PAY AMOUNT' },
        { key: 'method', label: 'METHOD' },
        { key: 'trade_status', label: 'STATUS' },
        { key: 'channel_order_id', label: 'PARTNER ID' },
        { key: 'channel_order_status', label: 'PARTNER STATUS' },
        { key: 'out_uid', label: 'MERCHANT UID' },
        { key: 'update_time', label: 'UPDATE TIME' },
      ],
    }
  },
  watch: {
    currentPage: function refetchSearchData(pageNum) {
      this.searchRequest.page_num = pageNum
      this.search(this.searchRequest)
    },
  },
  created() {
    this.search(this.searchRequest)
  },
  methods: {
    searchRequst() {
      this.searchRequest.user_name = this.getUserName()
    },
    search(params) {
      this.searchRequest = params
      this.searchRequst()
      fetchOrderIdList(
        this.searchRequest,
        records => {
          this.records = records.list
          this.totalTransactions = records.total
          this.dataMeta.from = this.currentPage * 10 - (10 - 1)
          this.dataMeta.to = this.totalTransactions - this.currentPage * 10 > 0 ? this.currentPage * 10 : this.totalTransactions
          this.dataMeta.of = this.totalTransactions
          this.$bvToast.toast('Success fetching Transactions', {
            title: 'Success',
            icon: 'AlertTriangleIcon',
            variant: 'success',
            toaster: 'b-toaster-top-right',
            solid: true,
          })
        },
        fail => {
          this.showAlert('Warning', `Fetch records with ${fail}`)
        },
      )
    },
    resolveStatusVariant(status) {
      switch (status) {
        case 'Processing':
          return 'primary'
        case 'Success':
          return 'success'
        case 'ChargeBack':
          return 'danger'
        case 'Refunded':
        case 'PartialRefund':
          return 'danger'
        case 'RiskControl':
        case 'Dispute':
          return 'warning'
        case 'Refused':
          return 'info'
        default:
          return 'secondary'
      }
    },
    getUserName() {
      const userString = localStorage.getItem('userData')
      if (userString !== null && userString !== undefined) {
        const user = JSON.parse(userString)
        return user.realName
      }
      return ''
    },
    showAlert(icon, title, text) {
      this.$swal({
        icon,
        title,
        text,
        customClass: {
          confirmButton: `btn btn-${icon}`,
        },
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
